<template>
  <td class="action-buttons-td no-print text-center"
      ref="actionButtonsTd"
      v-if="(options.actions && options.actions.some(r => ['edit','delete'].includes(r))) || options.actionscomponent">
    <a class="px-1 py-0 py-md-2 action-dots"
       :class="{
          'd-md-none d-inline-block': !dotsMenu
       }"
       @click="dotsPressed">
      <DotsSvg class="svg-gray" style="pointer-events: none"/>
    </a>
    <transition name="fade" mode="out-in">
      <div class="action-buttons-div"
           ref="actionsMenu"
           v-if="!dotsMenu || mob_expanded"
           :data-rows-count="rowsCount"
           :class="{
            'mobile-actions': isMobile || dotsMenu,
            'action-buttons-fixed': actionsMenuIsFixed,
            expanded: mob_expanded
         }"
           :style="{ bottom: posCalc.bottom, top: posCalc.top, right: posCalc.right }"
           v-click-outside="clickedOutside">
        <component v-if="options.actionscomponent"
                   :is="actioncomponents[options.actionscomponent]"
                   :configurationId="options.optionsId || 'default'"
                   :expanded="mob_expanded"
                   :object="object"/>
        <a class="data-table-action"
           :title="!mob_expanded ? $t('edit') : ''"
           v-b-tooltip.hover
           @click="editRow"
           v-if="canEdit">
          <EditSvg class="svg-stroke-light"/><span class="action-button-mob-title">{{ $t('edit') }}</span>
        </a>
        <a class="data-table-action"
           :title="!mob_expanded ? $t('sorting') : ''"
           v-b-tooltip.hover
           @click="sortRow"
           v-if="canSort">
          <SortSvg class="svg-stroke-light svg-size-xl"/><span class="action-button-mob-title">{{ $t('sorting') }}</span>
        </a>
        <a class="data-table-action delete-action"
           :title="!mob_expanded ? $t('delete') : ''"
           v-b-tooltip.hover
           @click="deleteRow"
           v-if="canDelete">
          <DeleteSvg :class="{ 'svg-stroke-red': mob_expanded, 'svg-stroke-light': !mob_expanded }"/><span class="action-button-mob-title">{{ $t('delete') }}</span>
        </a>
        <component v-if="options.actionscomponentEnd"
                   :is="actioncomponents[options.actionscomponentEnd]"
                   :expanded="mob_expanded"
                   :object="object"/>
      </div>
    </transition>
  </td>
</template>

<script>
import EditSvg from '@/assets/svg-vue/general/edit2.svg'
import DeleteSvg from '@/assets/svg-vue/general/delete2.svg'
import DotsSvg from '@/assets/svg-vue/header/horizontal_dots.svg'
import SortSvg from '@/assets/svg-vue/general/sort.svg'
import { mapState} from "vuex"
import { templateTypesToModelNames } from "@/dictionaries/dictionary"
import { copyObject } from "@/extensions/prototypes/prototypes"
import {EloquentService} from "@/services/api/eloquent.api.service"

export default {
  name: "ActionButtons",
  components: {
    EditSvg,
    DeleteSvg,
    DotsSvg,
    SortSvg
  },
  props: {
    options: {
      type: Object
    },
    index: {
      required: true
    },
    module: {
      type: String
    },
    object: {
      required: true,
      type: Object
    },
    rowsCount: {
      type: Number,
      default: 0
    },
    getTableHeight: {
      type: Function
    }
  },
  data() {
    return {
      mob_expanded: false,
      justOpened: false,
      styleCounter: 0
    }
  },
  methods: {
    editRow() {
      let newObject = copyObject(this.object)
      if(this.options.editAdditional) {
        newObject = {
          ...this.options.editAdditional,
          ...newObject
        }
      }
      this.$store.commit('setDataTableOptionsPath', this.options?.optionsPath || null)
      this.$store.commit('setModule', this.module)
      this.$store.commit('setSelectedModel', newObject)
      this.$store.commit('setShowModal', true)
    },
    async deleteRow() {
      let mes = 'are_you_sure_you_want_to_delete'
      if(this.options.deletemessage) mes = this.options.deletemessage
      if(!confirm(this.$t(mes))) return
      const successMessage = this.$t('success_message')
      let model = null
      if(this.options.model === 'general_template') {
        model = templateTypesToModelNames[this.object.template_type]
      }
      let additionalParams = null
      if(this.options.prepareParams) {
        additionalParams = {}
        this.options.prepareParams.forEach(x => {
          if(this.object[x]) additionalParams[x] = this.object[x]
        })
      }
      const id = this.object[this.options.primaryKey]
      if(this.options.checkPreDelete) {
        const preDeleteMessage = await EloquentService.preDelete(model || this.viewModel, id, this.superadmin)
        if(preDeleteMessage?.data) {
          if(!confirm(preDeleteMessage.data)) return
        }
      }
      try {
        await this.$store.dispatch('deleteModel', {
          id,
          model,
          superadmin: this.superadmin,
          additionalParams
        })
        this.$noty.info(successMessage)
      } catch (e) {
        console.log(e)
      }
    },
    sortRow() {
      this.$bvModal.show('sort-modal')
    },
    dotsPressed() {
      this.justOpened = true
      this.mob_expanded = !this.mob_expanded
      this.recalcPosition()
      setTimeout(() => {
        this.justOpened = false
      },20)
    },
    clickedOutside() {
      // console.log('clicked outside', this.index)
      if(!this.justOpened && !document.body.classList.contains('modal-open')) {
        this.mob_expanded = false
      }
    },
    recalcPosition() {
      this.styleCounter++
    }
  },
  computed: {
    ...mapState({
      isMobile: state => state.dom.isMobile,
      viewModel: state => state.datatable.viewModel,
    }),
    actioncomponents () {
      const components = require.context(`@/components/parts/datatable/actionbuttons/`, true, /\.vue$/i)
      let arr = {}
      components.keys().map(x => {
        arr[x.split('/').pop().split('.')[0]] = components(x).default
      })
      return arr
    },
    ...mapState({
      rights: state => state.auth.rights,
      superadmin: state => state.auth.superadmin,
    }),
    canDelete() {
      if(!this.options.actions.includes('delete')) {
        return false
      }
      if(this.options.deleteCondition && !this.options.deleteCondition(this.object, this.$store)) {
        return false
      }
      if(this.options.model === 'record' && this.object.status == 2) return false
      if(this.options.rights && this.options.rights.delete && !this.rights.includes(this.options.rights.delete)) {
        return false
      }
      return true
    },
    actionsMenuIsFixed() {
      return this.dotsMenu && !this.isMobile && this.rowsCount < 6
    },
    canEdit() {
      if(!this.options.actions.includes('edit')) {
        return false
      }
      if(this.options.editCondition && !this.options.editCondition(this.object, this.$store)) {
        return false
      }
      if(this.options.rights && this.options.rights.edit && !this.rights.includes(this.options.rights.edit)) {
        return false
      }
      return true
    },
    canSort() {
      return this.options.actions.includes('sort')
    },
    dotsMenu() {
      return this.options.fixedSizeTable
    },
    posCalc() {
      const res = {
        bottom: 'auto',
        top: '20px',
        right: 'auto',
        styleCounter: this.styleCounter
      }
      if(!this.dotsMenu) {
        return res
      }
      const rowsLeft = this.rowsCount - this.index
      let stickToBottom = rowsLeft < 3 // plan B
      const actionButtonsTd = this.$refs.actionButtonsTd.getBoundingClientRect()
      const tableDimensions = this.getTableHeight()
      if(tableDimensions) {
        const offsetFromTop = actionButtonsTd.top - (tableDimensions.top || 0)
        const heightLeft = tableDimensions.height - offsetFromTop
        stickToBottom = heightLeft < 240  // plan A
      }
      const actionsTh = document.querySelector('.actions-th-header')
      const right = Math.max(actionsTh ? (actionsTh.getBoundingClientRect().width + 2) : 42, 42)
      res.right = right + 'px'
      let fixedTop = null
      let fixedBottom = null
      if(this.actionsMenuIsFixed) {
        if(stickToBottom) {
          fixedBottom = (window.innerHeight - actionButtonsTd.bottom) + 'px'
          fixedTop = 'auto'
        } else {
          fixedTop = (actionButtonsTd.top) + 'px'
          fixedBottom = 'auto'
        }
      }
      if(!stickToBottom) {
        res.bottom = fixedBottom || 'auto'
        res.top = fixedTop || '20px'
        return res
      }
      res.bottom = fixedBottom || '0px'
      res.top = fixedTop || 'auto'
      return res
    }
  },
  unmounted() {
    window.removeEventListener('scroll', this.recalcPosition)
    window.removeEventListener('resize', this.recalcPosition)
  },
  mounted() {
    window.addEventListener('scroll', this.recalcPosition)
    window.addEventListener('resize', this.recalcPosition)
  }
}
</script>
